import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import '../styles.less'
import ReviseContractStaff from '../../../widgets/revise/ReviseContractStaff'
import AgreementAdditionalWidgets from '../../../widgets/agreementAdditional/AgreementAdditionalWidgets'
import AgreementAdditional from '../../../widgets/agreementAdditional/AgreementAdditional'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { getChangeAgreement } from '../../../redux/actions/contract'
import { startLoading, doneLoading } from '../../../utils/loading'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { getAiEvaluationResult } from '../../../redux/actions/aiEvaluation'

export default function AgreementAdditionalView() {
  //ทำข้อตกลงเพิ่มเติม
  const [isEditAll, setIsEditAll] = useState(false)
  const [showHead, setShowHead] = useState(true)
  const [showSubmit, setShowSubmit] = useState(false)
  const [schema, setSchema] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [isLoading, setIsLoading] = useState(false)
  const [section1, setSection1] = useState()
  const [error, setError] = useState()

  // const [evaluationResultSchema, setEvaluationResultSchema] = useState()

  // const hindPanel = () => {
  //   setHideHead(true)
  //   setHideSubmit(false)
  // }

  useEffect(() => {
    projectId && handleGetSchema(projectId)
  }, [])

  useEffect(() => {
    console.log(schema)
    let selected = false
    schema?.forms?.projectFeedback?.revises?.forEach((element) => {
      element?.subItems?.forEach((item) => {
        if (item.selected) {
          selected = true
        }
      })
    })
    if (selected) {
      setShowSubmit(true)
      // console.log('setHideSubmit')
      // handleGetEvaluationResult()
    } else {
      setShowSubmit(false)
    }
  }, [schema])

  const handleGetSchema = async (projectVersionId) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getChangeAgreement(projectVersionId)
      setSchema(response.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  // const handleGetEvaluationResult = async () => {
  //   try {
  //     const response = await getAiEvaluationResult(projectId)

  //     if (response) {
  //       setEvaluationResultSchema(response)
  //     }
  //   } catch (e) {}
  // }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal statusDefault={6}>
        <ContentHeader header={schema?.header} subHeader={schema?.subHeader} />

        {schema && (
          <>
            {showHead && schema?.forms?.agreementDetails && (
              <AgreementAdditionalWidgets
                showCommandButton={!schema.forms.agreementDetails.disabled}
                isEditAll={isEditAll}
                formSchema={schema.forms.agreementDetails}
              />
            )}

            {schema?.forms?.projectFeedback && (
              <ReviseContractStaff
                showCommandButton={!schema.forms.projectFeedback.disabled}
                isEditAll={isEditAll}
                schema={schema.forms.projectFeedback}
                onSuccess={(res) =>
                  setSchema((state) => ({
                    ...state,
                    forms: {
                      ...state.forms,
                      projectFeedback: res,
                    },
                  }))
                }
              />
            )}

            {showSubmit && schema?.forms?.requestNote?.note && (
              <AgreementAdditional
                showCommandButton={!schema.forms.requestNote.disabled}
                isEditAll={isEditAll}
                schema={schema.forms.requestNote}
                isAIEvaliation={schema?.forms?.isEvaluation}
                // evaluationResult={evaluationResultSchema}
                // hideHead={showHead}
                // hideSubmit={showSubmit}
                // section1={section1}
                // onCallBack={(e) => setNewState(e)}
              />
            )}

            <br />
          </>
        )}
      </SidebarProposal>
    </>
  )
}
